import React from 'react';
import {
  Badge,
  Box,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  List,
  ListItem,
  Text,
  VStack,
} from '@chakra-ui/react';

const WarehouseHistoryDrawer = ({ isOpen, onClose, item }) => {
  const history = item?.history || [];

  const formatAction = (action) => {
    const time = action.at ? new Date(action.at).toLocaleString() : '';
    const who = action.userEmail || action.userId || 'N/D';
    let description = action.type;
    if (action.type === 'add') {
      description = `Aggiunta di ${action.delta} unità`;
    } else if (action.type === 'remove') {
      description = `Rimozione di ${Math.abs(action.delta)} unità`;
    } else if (action.type === 'create') {
      description = `Creazione (qty: ${action.newQuantity} unità)`;
    } else if (action.type === 'rename') {
      description = 'Rinominato';
    } else if (action.type === 'updateMinQuantity') {
      description = 'Aggiornata soglia minima';
    }

    return `${description} da ${who}${time ? ' - ' + time : ''}`;
  };

  return (
    <Drawer isOpen={isOpen} placement='right' onClose={onClose} size='sm'>
      <DrawerOverlay />
      <DrawerContent bg='#2d3748' color='white'>
        <DrawerCloseButton />
        <DrawerHeader>
          Storico azioni (ultime 30)
          {item && (
            <Text fontSize='sm' mt={1}>
              Prodotto: <strong>{item.name}</strong>
            </Text>
          )}
        </DrawerHeader>

        <DrawerBody>
          {history.length === 0 ? (
            <Text fontSize='sm'>Nessuna azione registrata per questo prodotto.</Text>
          ) : (
            <List spacing={3}>
              {history.map((action, index) => (
                <ListItem key={index}>
                  <VStack align='start' spacing={1}>
                    <Box>
                      <Badge mr={2}>{action.type}</Badge>
                      <Text as='span' fontSize='sm'>
                        {formatAction(action)}
                      </Text>
                    </Box>
                    {'previousQuantity' in action && 'newQuantity' in action && (
                      <Text fontSize='xs' color='gray.300'>
                        Quantità: {action.previousQuantity} → {action.newQuantity}
                      </Text>
                    )}
                  </VStack>
                </ListItem>
              ))}
            </List>
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default WarehouseHistoryDrawer;

